import React, { useState, useCallback } from "react";
import ProfileInfo from "./user-menu/profile-info";
import UserMenuEntries from "./user-menu/menu-entries";
import { useAuthDataContext } from "components/auth";
import { useCurrentCustomerContext } from "components/current-customer-context";
import Menu from "@material-ui/core/Menu";
import withStyles from "components/with-styles";
import styles from "./styles/user-menu.css.js";

const UserMenu = ({ classes }) => {
  const { currentCustomerId, customers } = useCurrentCustomerContext();
  const { user, hasAdminPrivileges } = useAuthDataContext();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleMenu = useCallback(event => setAnchorEl(event.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const currentCustomer = customers?.find(c => c._id === currentCustomerId) ?? null;
  const customerName = currentCustomer ? currentCustomer.description : null;

  const profileMenuText = hasAdminPrivileges || !customerName ? `${user.sub}` : `${user.sub} @ ${customerName}`;

  return (
    <>
      <ProfileInfo onClick={handleMenu} text={profileMenuText} />
      <Menu
        classes={{ paper: classes.menuPaper }}
        className={classes.profileMenu}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <UserMenuEntries anchorEl={anchorEl} open={open} onClose={handleClose} currentClient={customerName} />
      </Menu>
    </>
  );
};

export default withStyles(styles)(UserMenu);
